import { enqueueSnackbar, SnackbarKey, SnackbarMessage } from "notistack"

const API_ERROR_DISPLAY_DELAY = 100

interface PendingApiError {
  message: string
  snackbarKey: SnackbarKey
  timeoutId: ReturnType<typeof setTimeout>
}

const pendingApiErrors: PendingApiError[] = []
const globalApiErrorSnackbarKeys = new Set<SnackbarKey>()
let snackbarSequence = 0

export const queueApiErrorSnackbar = (message: string) => {
  const snackbarKey = `api-error-${++snackbarSequence}`
  const pendingError: PendingApiError = {
    message,
    snackbarKey,
    timeoutId: setTimeout(() => {
      const index = pendingApiErrors.indexOf(pendingError)

      if (index !== -1) {
        pendingApiErrors.splice(index, 1)
      }

      globalApiErrorSnackbarKeys.add(snackbarKey)
      enqueueSnackbar(message, { key: snackbarKey, variant: "error" })
    }, API_ERROR_DISPLAY_DELAY),
  }

  pendingApiErrors.push(pendingError)
}

export const consumeApiErrorMessage = (
  snackbarKey: SnackbarKey,
  fallbackMessage: SnackbarMessage,
): SnackbarMessage => {
  if (globalApiErrorSnackbarKeys.delete(snackbarKey)) {
    return fallbackMessage
  }

  const pendingError = pendingApiErrors.shift()

  if (!pendingError) {
    return fallbackMessage
  }

  clearTimeout(pendingError.timeoutId)
  return pendingError.message
}
